import React from 'react';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>
      <p className="updated-date">Updated: 23rd of May 2025</p>
      
      <section>
        <p>
          SOPHIE ("we", "us", "our") is committed to protecting your privacy and ensuring transparency in how we use your personal data. This Privacy Policy explains how we collect, use, and share your personal information when you interact with our advertising and marketing, including through social media platforms (e.g., LinkedIn, Meta), search engines (e.g., Google), and landing pages promoting our CRM automation solutions.
        </p>
      </section>

      <section>
        <h2>1. Who We Are</h2>
        <p>SOPHIE is a company headquartered in the United Kingdom.</p>
        <ul>
          <li><strong>Company Name:</strong> Sophie Datagen Ltd</li>
          <li><strong>Registered Address:</strong> 128 City Road, London, GB</li>
          <li><strong>Company Number:</strong> 16157376</li>
          <li><strong>Contact:</strong> <a href="mailto:hello@sophiedoc.ai">hello@sophiedoc.ai</a></li>
        </ul>
      </section>

      <section>
        <h2>2. What Personal Data We Collect</h2>
        <p>We may collect the following types of personal data through our advertising efforts:</p>
        <ul>
          <li><strong>Identifiers:</strong> Name, email address, job title, company name, country/region</li>
          <li><strong>Device and Usage Data:</strong> IP address, browser type, device type, and interaction data (e.g., clicks on our ads or time spent on our landing pages)</li>
          <li><strong>CRM Data:</strong> If you submit a form (e.g., to request a demo), we store your information in our CRM (e.g., HubSpot or Salesforce)</li>
          <li><strong>Marketing Data:</strong> Responses to ads, open/click rates on email campaigns, LinkedIn Lead Gen Forms, and cookies or tracking pixels from platforms like Google Ads, LinkedIn, and Meta</li>
        </ul>
      </section>

      <section>
        <h2>3. How We Use Your Data</h2>
        <p>We use your data for the following purposes:</p>
        <ul>
          <li>To serve and personalize ads (retargeting, lookalike audiences, etc.)</li>
          <li>To analyze ad performance and optimize campaigns</li>
          <li>To contact you (with your consent) about SOPHIE's products or offers</li>
          <li>To manage your demo or inquiry request via our CRM system</li>
          <li>To ensure compliance with applicable laws and regulations</li>
        </ul>
      </section>

      <section>
        <h2>4. Legal Basis for Processing</h2>
        <p>Under the UK GDPR / EU GDPR, our lawful bases for processing include:</p>
        <ul>
          <li><strong>Consent:</strong> For marketing communications and cookies</li>
          <li><strong>Legitimate Interests:</strong> To promote SOPHIE's CRM automation tools to relevant professionals</li>
          <li><strong>Contract:</strong> To follow up on demo requests or inquiries</li>
        </ul>
        <p>
          For California Residents (under the CCPA/CPRA), we do not sell personal data, but we may share data with advertising platforms for targeted ads, which may qualify as a "sale" or "sharing" under California law. You may opt out at any time (see Section 8).
        </p>
      </section>

      <section>
        <h2>5. Who We Share Data With</h2>
        <p>We may share your data with:</p>
        <ul>
          <li><strong>Advertising platforms:</strong> LinkedIn, Meta, Google Ads</li>
          <li><strong>CRM providers:</strong> HubSpot, Salesforce</li>
          <li><strong>Marketing partners:</strong> Agencies or freelancers helping manage campaigns</li>
          <li><strong>Analytics tools:</strong> Google Analytics, LinkedIn Insights Tag</li>
          <li><strong>Legal authorities:</strong> If required by law or to protect our legal interests</li>
        </ul>
        <p>All service providers are bound by data protection agreements.</p>
      </section>

      <section>
        <h2>6. Data Retention</h2>
        <p>We keep your personal data only as long as necessary for the purposes stated above, or as required by law. This usually means:</p>
        <ul>
          <li>Up to 12 months for ad engagement data</li>
          <li>Up to 24 months for CRM and lead gen data (unless you become a customer)</li>
          <li>Indefinitely for anonymized analytics data</li>
        </ul>
        <p>You can request deletion at any time (see Section 8).</p>
      </section>

      <section>
        <h2>7. Your Rights</h2>
        <p>Depending on your location, you may have the right to:</p>
        <ul>
          <li>Access the data we hold about you</li>
          <li>Correct inaccurate information</li>
          <li>Delete your personal data</li>
          <li>Object to or restrict processing</li>
          <li>Withdraw consent (e.g., unsubscribe or cookie preferences)</li>
          <li>File a complaint with your local data protection authority</li>
        </ul>
        <p>To exercise these rights, contact us at: <a href="mailto:hello@sophiedoc.ai">hello@sophiedoc.ai</a></p>
      </section>

      <section>
        <h2>8. Your Privacy Choices</h2>
        <ul>
          <li><strong>Email marketing:</strong> You can unsubscribe anytime via a link in our emails</li>
          <li><strong>Cookies:</strong> Use the cookie banner or cookie settings</li>
          <li><strong>Targeted Ads:</strong> You can opt out via:
            <ul>
              <li>Google Ads Settings</li>
              <li>LinkedIn Ad Preferences</li>
              <li>Meta Ad Preferences</li>
              <li>Your Privacy Choices – Do Not Sell/Share My Info [if applicable for CCPA]</li>
            </ul>
          </li>
        </ul>
      </section>

      <section>
        <h2>9. International Transfers</h2>
        <p>
          As a UK-based company working with international platforms, we may transfer your data outside the UK or EEA. Where we do, we ensure appropriate safeguards are in place (e.g., Standard Contractual Clauses).
        </p>
      </section>

      <section>
        <h2>10. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. When we do, we'll update the effective date and notify users where appropriate.
        </p>
      </section>

      <section>
        <h2>Questions?</h2>
        <p>We're here to help.</p>
        <p>Email us at <a href="mailto:hello@sophiedoc.ai">hello@sophiedoc.ai</a></p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;